(() => {
  function closeMenus(except) {
    document.querySelectorAll('.pg-nav__details[open]').forEach(menu => {
      if (menu !== except) menu.open = false;
    });
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('.pg-nav__details > summary');
    if (summary) closeMenus(summary.parentElement);
    else if (!event.target.closest('.pg-nav__details')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const current = event.target.closest('.pg-nav__details[open]');
    closeMenus();
    if (current) current.querySelector('summary').focus();
  });
})();
